/**
 * The deadlines query key, on its own so the write hooks that move a statutory
 * clock — a stage save, a service record, a filing, a warrant — can invalidate
 * the dashboard's deadline list without importing the deadlines module (which
 * itself reads the file list, and would make the import circular).
 */
export const deadlinesKeys = {
  all: ['deadlines'] as const,
};
